import React from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { BRAND, IMAGES } from "../../lib/site";
import { Reveal } from "../../lib/motion";

const shots = [
  { src: IMAGES.g3, label: "Burgundy Box Braids", tall: true },
  { src: IMAGES.g1, label: "Copper Rope Twists", tall: false },
  { src: IMAGES.g4, label: "Honey Twists", tall: false },
  { src: IMAGES.g2, label: "Boho Knotless", tall: true },
];

export const Gallery = () => {
  return (
    <section id="gallery" className="py-24 md:py-32 bg-[#f3ebe1]" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <Reveal>
            <p className="font-body text-xs uppercase tracking-[0.3em] text-[#c96c31] mb-5">
              The Portfolio
            </p>
            <h2 className="font-display font-light leading-[0.95] tracking-tight text-[#2c1e16] text-4xl sm:text-5xl lg:text-6xl max-w-2xl">
              Real crowns, real craft
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <a
              data-testid="gallery-instagram-link"
              href={BRAND.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-body text-sm uppercase tracking-widest text-[#2c1e16] hover:text-[#c96c31] transition-colors"
            >
              <Instagram size={18} /> Follow {BRAND.handle}
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {shots.map((s, i) => (
            <Reveal key={i} delay={(i % 4) * 0.08}>
              <motion.figure
                data-testid={`gallery-item-${i}`}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4 }}
                className={`group relative overflow-hidden rounded-2xl border border-[#2c1e16]/10 ${
                  s.tall ? "aspect-[3/5] lg:mt-0" : "aspect-[3/4] lg:mt-12"
                }`}
              >
                <img
                  src={s.src}
                  alt={s.label}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#2c1e16]/80 to-transparent">
                  <span className="font-body text-xs md:text-sm uppercase tracking-widest text-[#f9f6f0]">
                    {s.label}
                  </span>
                </figcaption>
              </motion.figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
